function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { EBeneficiary } from "./StepContent/StepListBeneficiary";
import { ELegacySimulatorRegion } from "./StepContent/StepRegion";
var _obj;
var spousesData = (_obj = {}, _define_property(_obj, ELegacySimulatorRegion.FLANDRE, [
    {
        amount: 50000,
        percentage: 3
    },
    {
        amount: 250000,
        percentage: 9
    },
    {
        amount: Infinity,
        percentage: 27
    }
]), _define_property(_obj, ELegacySimulatorRegion.BRUXELLES_CAPITALE, [
    {
        amount: 50000,
        percentage: 3
    },
    {
        amount: 100000,
        percentage: 8
    },
    {
        amount: 175000,
        percentage: 9
    },
    {
        amount: 250000,
        percentage: 18
    },
    {
        amount: 500000,
        percentage: 24
    },
    {
        amount: Infinity,
        percentage: 30
    }
]), _define_property(_obj, ELegacySimulatorRegion.WALLONIE, [
    {
        amount: 12500,
        percentage: 3
    },
    {
        amount: 25000,
        percentage: 4
    },
    {
        amount: 50000,
        percentage: 5
    },
    {
        amount: 100000,
        percentage: 7
    },
    {
        amount: 150000,
        percentage: 10
    },
    {
        amount: 200000,
        percentage: 14
    },
    {
        amount: 250000,
        percentage: 18
    },
    {
        amount: 500000,
        percentage: 24
    },
    {
        amount: Infinity,
        percentage: 30
    }
]), _obj);
var _obj1;
var brothersAndSistersData = (_obj1 = {}, _define_property(_obj1, ELegacySimulatorRegion.FLANDRE, [
    {
        amount: 35000,
        percentage: 25
    },
    {
        amount: 75000,
        percentage: 30
    },
    {
        amount: Infinity,
        percentage: 55
    }
]), _define_property(_obj1, ELegacySimulatorRegion.BRUXELLES_CAPITALE, [
    {
        amount: 12500,
        percentage: 20
    },
    {
        amount: 25000,
        percentage: 25
    },
    {
        amount: 50000,
        percentage: 30
    },
    {
        amount: 100000,
        percentage: 40
    },
    {
        amount: 175000,
        percentage: 55
    },
    {
        amount: 250000,
        percentage: 60
    },
    {
        amount: Infinity,
        percentage: 65
    }
]), _define_property(_obj1, ELegacySimulatorRegion.WALLONIE, [
    {
        amount: 12500,
        percentage: 20
    },
    {
        amount: 25000,
        percentage: 25
    },
    {
        amount: 75000,
        percentage: 35
    },
    {
        amount: 175000,
        percentage: 50
    },
    {
        amount: Infinity,
        percentage: 65
    }
]), _obj1);
var _obj2;
var auntsOrUnclesAndNephewsOrNiecesData = (_obj2 = {}, _define_property(_obj2, ELegacySimulatorRegion.FLANDRE, [
    {
        amount: 35000,
        percentage: 25
    },
    {
        amount: 75000,
        percentage: 30
    },
    {
        amount: Infinity,
        percentage: 55
    }
]), _define_property(_obj2, ELegacySimulatorRegion.BRUXELLES_CAPITALE, [
    {
        amount: 50000,
        percentage: 35
    },
    {
        amount: 100000,
        percentage: 50
    },
    {
        amount: 175000,
        percentage: 60
    },
    {
        amount: Infinity,
        percentage: 70
    }
]), _define_property(_obj2, ELegacySimulatorRegion.WALLONIE, [
    {
        amount: 12500,
        percentage: 25
    },
    {
        amount: 25000,
        percentage: 30
    },
    {
        amount: 75000,
        percentage: 40
    },
    {
        amount: 175000,
        percentage: 55
    },
    {
        amount: Infinity,
        percentage: 70
    }
]), _obj2);
var _obj3;
var otherPersonsData = (_obj3 = {}, _define_property(_obj3, ELegacySimulatorRegion.FLANDRE, [
    {
        amount: 35000,
        percentage: 25
    },
    {
        amount: 75000,
        percentage: 45
    },
    {
        amount: Infinity,
        percentage: 55
    }
]), _define_property(_obj3, ELegacySimulatorRegion.BRUXELLES_CAPITALE, [
    {
        amount: 50000,
        percentage: 40
    },
    {
        amount: 75000,
        percentage: 55
    },
    {
        amount: 175000,
        percentage: 65
    },
    {
        amount: Infinity,
        percentage: 80
    }
]), _define_property(_obj3, ELegacySimulatorRegion.WALLONIE, [
    {
        amount: 12500,
        percentage: 30
    },
    {
        amount: 25000,
        percentage: 35
    },
    {
        amount: 75000,
        percentage: 60
    },
    {
        amount: Infinity,
        percentage: 80
    }
]), _obj3);
var _obj4;
var associationsFoundationsInstitutionsData = (_obj4 = {}, _define_property(_obj4, ELegacySimulatorRegion.FLANDRE, 0), _define_property(_obj4, ELegacySimulatorRegion.BRUXELLES_CAPITALE, 7), _define_property(_obj4, ELegacySimulatorRegion.WALLONIE, 7), _obj4);
var getNetAmount = function(data, amount) {
    if (!amount) return 0;
    var list = [];
    var previousThreshold = 0;
    var remainingAmount = amount;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, threshold = _step_value.amount, percentage = _step_value.percentage;
            var currentAmount = threshold - previousThreshold;
            remainingAmount -= currentAmount;
            if (remainingAmount <= 0) {
                list.push({
                    a: amount - previousThreshold,
                    p: percentage
                });
                break;
            } else {
                list.push({
                    a: currentAmount,
                    p: percentage
                });
            }
            previousThreshold = threshold;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var result = 0;
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = list[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var _step_value1 = _step1.value, a = _step_value1.a, p = _step_value1.p;
            result += a * p / 100;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return amount - result;
};
export var calculationFormula = function(region, beneficiaries) {
    var result = {
        sans: [],
        avec: [],
        duvePercent: 0
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = beneficiaries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var beneficiary = _step.value;
            var _beneficiary_legs, _beneficiary_legsWithoutLegacy;
            var relationship = beneficiary.relationship;
            var netAmount = 0;
            var netAmountWithoutLegacy = 0;
            var legs = parseFloat(((_beneficiary_legs = beneficiary.legs) === null || _beneficiary_legs === void 0 ? void 0 : _beneficiary_legs.replace(".", "")) || "0");
            var legsWithoutLegacy = parseFloat(((_beneficiary_legsWithoutLegacy = beneficiary.legsWithoutLegacy) === null || _beneficiary_legsWithoutLegacy === void 0 ? void 0 : _beneficiary_legsWithoutLegacy.replace(".", "")) || "0");
            switch(relationship){
                case EBeneficiary.IMMEDIATE_FAMILY:
                    netAmount = getNetAmount(spousesData[region], legs);
                    netAmountWithoutLegacy = getNetAmount(spousesData[region], legsWithoutLegacy);
                    break;
                case EBeneficiary.SIBLINGS:
                    netAmount = getNetAmount(brothersAndSistersData[region], legs);
                    netAmountWithoutLegacy = getNetAmount(brothersAndSistersData[region], legsWithoutLegacy);
                    break;
                case EBeneficiary.EXTENDED_FAMILY:
                    netAmount = getNetAmount(auntsOrUnclesAndNephewsOrNiecesData[region], legs);
                    netAmountWithoutLegacy = getNetAmount(auntsOrUnclesAndNephewsOrNiecesData[region], legsWithoutLegacy);
                    break;
                case EBeneficiary.OTHERS:
                    netAmount = getNetAmount(otherPersonsData[region], legs);
                    netAmountWithoutLegacy = getNetAmount(otherPersonsData[region], legsWithoutLegacy);
                    break;
                default:
                    break;
            }
            result.sans.push({
                beneficiary: beneficiary,
                legs: legsWithoutLegacy,
                droits: legsWithoutLegacy - netAmountWithoutLegacy,
                net: netAmountWithoutLegacy,
                advantage: netAmountWithoutLegacy - legsWithoutLegacy
            });
            if (region === ELegacySimulatorRegion.FLANDRE) {
                result.avec.push({
                    beneficiary: beneficiary,
                    legs: legs,
                    droits: legs - netAmount,
                    net: netAmount,
                    advantage: netAmount - legs
                });
            } else {
                result.avec.push({
                    beneficiary: beneficiary,
                    legs: legs,
                    droits: legs - netAmount,
                    net: legs,
                    advantage: legs - netAmount
                });
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    result.duvePercent = associationsFoundationsInstitutionsData[region];
    return result;
};
var dataWithLegacy = function(calculationResult, duveAmount) {
    var inheritanceRights = [];
    var data = (calculationResult === null || calculationResult === void 0 ? void 0 : calculationResult.avec.map(function(item) {
        inheritanceRights.push({
            relationship: item.beneficiary.relationship,
            value: item.droits
        });
        return {
            relation: item.beneficiary.relationship,
            name: item.beneficiary.name || "",
            legacy: item.legs,
            net: item.net,
            advantage: item.advantage
        };
    })) || [];
    var duveAmountInt = parseFloat(duveAmount.replace(".", ""));
    var duvePercent = duveAmountInt * ((calculationResult === null || calculationResult === void 0 ? void 0 : calculationResult.duvePercent) || 0) / 100;
    var duveNet = duveAmountInt - duvePercent;
    inheritanceRights.forEach(function(item) {
        duveNet -= item.value;
    });
    data === null || data === void 0 ? void 0 : data.push({
        relation: "duve-institute",
        name: "",
        legacy: duveAmountInt,
        "inheritance-rights": inheritanceRights,
        net: duveNet,
        advantage: duveNet
    });
    return data || [];
};
var dataWithoutLegacy = function(calculationResult) {
    var data = (calculationResult === null || calculationResult === void 0 ? void 0 : calculationResult.sans.map(function(item) {
        return {
            relation: item.beneficiary.relationship,
            name: item.beneficiary.name || "",
            legacy: item.legs,
            net: item.net,
            "inheritance-rights": item.droits,
            // advantage: item.advantage
            advantage: ""
        };
    })) || [];
    data === null || data === void 0 ? void 0 : data.push({
        relation: "duve-institute",
        name: "",
        legacy: 0,
        net: 0,
        "inheritance-rights": 0,
        advantage: "/"
    });
    return data || [];
};
var dataWithoutDuo = function(calculationResult, duveAmount) {
    var data = (calculationResult === null || calculationResult === void 0 ? void 0 : calculationResult.avec.map(function(item) {
        return {
            relation: item.beneficiary.relationship,
            name: item.beneficiary.name || "",
            legacy: item.legs,
            net: item.net,
            "inheritance-rights": item.droits
        };
    })) || [];
    var duveAmountInt = parseFloat(duveAmount.replace(".", ""));
    var duvePercent = duveAmountInt * ((calculationResult === null || calculationResult === void 0 ? void 0 : calculationResult.duvePercent) || 0) / 100;
    var duveNet = duveAmountInt - duvePercent;
    data === null || data === void 0 ? void 0 : data.push({
        relation: "duve-institute",
        name: "",
        legacy: duveAmountInt,
        net: duveNet,
        "inheritance-rights": 0
    });
    return data || [];
};
export var getAllData = function(calculationResult, duveAmount, hasDuo, region) {
    var _result_dataWithLegacy_find;
    var result = {
        dataWithoutLegacy: [],
        dataWithLegacy: [],
        dataWithoutDuo: [],
        netAmountDuve: 0,
        region: region
    };
    if (hasDuo) {
        result.dataWithoutLegacy = dataWithoutLegacy(calculationResult);
        result.dataWithLegacy = dataWithLegacy(calculationResult, duveAmount).map(function(item) {
            var _result_dataWithoutLegacy_find;
            var netWithOutLegacy = ((_result_dataWithoutLegacy_find = result.dataWithoutLegacy.find(function(el) {
                return el.relation === item.relation;
            })) === null || _result_dataWithoutLegacy_find === void 0 ? void 0 : _result_dataWithoutLegacy_find.net) || 0;
            return _object_spread_props(_object_spread({}, item), {
                advantage: item.net - netWithOutLegacy
            });
        });
    } else {
        result.dataWithoutDuo = dataWithoutDuo(calculationResult, duveAmount);
    }
    result.netAmountDuve = ((_result_dataWithLegacy_find = result.dataWithLegacy.find(function(item) {
        return item.relation === "duve-institute";
    })) === null || _result_dataWithLegacy_find === void 0 ? void 0 : _result_dataWithLegacy_find.net) || 0;
    return result;
};

//# sourceMappingURL=calculationFormula.js.map